<div class="modal-content border-0 shadow-lg">
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="bi bi-exclamation-triangle text-danger me-2"></i>
      <span>{{ title }}</span>
    </h5>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()" aria-label="Close"></button>
  </div>

  <div class="modal-body p-4">
    <p class="mb-2">{{ message }}</p>
    <p class="text-muted small mb-0">{{ warning }}</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">
      <i class="bi bi-x-circle"></i>
      <span>Cancel</span>
    </button>
    <button type="button" class="btn btn-danger" (click)="activeModal.close(true)">
      <i class="bi bi-trash3"></i>
      <span>Delete</span>
    </button>
  </div>
</div>
